<!--<template>-->
<!--    <div class="flex">-->
<!--        &lt;!&ndash; SIDEBAR (relative so submenu can be absolute to it) &ndash;&gt;-->
<!--        <div-->
<!--            :class="isOpen ? 'w-56' : 'w-16'"-->
<!--            class="relative min-h-screen bg-primary text-white flex flex-col pt-40 pb-4 transition-all duration-300 rounded-r-xl"-->
<!--            @mouseenter="openMainMenu"-->
<!--            @mouseleave="closeMainMenu(); closeSubmenu()"-->
<!--        >-->
<!--            <div class="flex flex-col gap-2 mt-6 px-2">-->
<!--                <template v-for="(item, index) in menuItems" :key="index">-->
<!--                    &lt;!&ndash; اگر آیتم زیرمنو دارد: فقط @mouseenter برای باز کردن &ndash;&gt;-->
<!--                    <div-->
<!--                        v-if="item.submenu"-->
<!--                        class=""-->
<!--                        @mouseenter="openSubmenu(index)"-->
<!--                    >-->
<!--                        &lt;!&ndash; Parent &ndash;&gt;-->
<!--                        <div-->
<!--                            :class="[-->
<!--                                activeParent === index ? 'bg-white text-primary' : '',-->
<!--                                'hover:bg-white hover:text-primary'-->
<!--                              ]"-->
<!--                            class="flex items-center gap-3 cursor-pointer px-3 py-2 rounded-md transition"-->
<!--                        >-->
<!--                            <component :is="item.icon" class="w-5 h-5"/>-->
<!--                            &lt;!&ndash;                        <component :is="item.icon" class="w-5 h-5"&ndash;&gt;-->
<!--                            &lt;!&ndash;                                   :class="activeSubmenu === index ? 'text-primary' : 'text-white'"/>&ndash;&gt;-->
<!--                            <span v-if="isOpen" class="whitespace-nowrap">{{ item.label }}</span>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; اگر آیتم زیرمنو ندارد: از router-link استفاده کن &ndash;&gt;-->
<!--                    <router-link-->
<!--                        v-else-->
<!--                        :to="item.route"-->
<!--                        active-class="bg-white text-primary"-->
<!--                        class="flex items-center gap-3 px-3 py-2 rounded-md transition hover:bg-white hover:text-primary"-->
<!--                        exact-active-class="bg-white text-primary"-->
<!--                    >-->
<!--                        <component :is="item.icon" class="w-5 h-5"/>-->
<!--                        <span v-if="isOpen" class="whitespace-nowrap">{{ item.label }}</span>-->
<!--                    </router-link>-->
<!--                </template>-->
<!--            </div>-->

<!--            &lt;!&ndash; SUBMENU: کاملأ به ارتفاع سایدبار و چسبیده به آن &ndash;&gt;-->
<!--            <transition name="submenu-fade">-->
<!--                <div-->
<!--                    v-if="activeSubmenu !== null && menuItems[activeSubmenu].submenu"-->
<!--                    class="absolute left-full top-0 h-full w-72 bg-white text-gray-800 rounded-lg shadow-lg p-4 z-50 overflow-auto"-->
<!--                >-->
<!--                    &lt;!&ndash; header small &ndash;&gt;-->
<!--                    <div class="text-lg text-center font-semibold text-gray-500 mt-20 mb-4 uppercase">-->
<!--                        {{ menuItems[activeSubmenu].label }}-->
<!--                    </div>-->

<!--                    &lt;!&ndash; items داخل زیرمنو؛ می‌تونی فهرست رو طوری استایل بدی که با آیتم‌های سایدبار هم ترازبندی شود &ndash;&gt;-->
<!--                    <div class="flex flex-col gap-2">-->
<!--                        <div-->
<!--                            v-for="(sub, si) in menuItems[activeSubmenu].submenu"-->
<!--                            :key="si"-->
<!--                            :class="activeSubmenuItem === si && activeParent === activeSubmenu ? 'bg-white text-primary' : 'hover:bg-orange-50 hover:text-orange-600'"-->
<!--                            class="flex items-center gap-3 rounded-md cursor-pointer transition"-->
<!--                            @click="goToPage(sub.route, si)"-->
<!--                        >-->
<!--                            &lt;!&ndash; می‌تونی آیکون هم اینجا اضافه کنی &ndash;&gt;-->
<!--                            <div class="w-12 h-12 flex justify-center items-center rounded-md border" :class="activeSubmenuItem === si && activeParent === activeSubmenu ? 'border-primary' : 'border-gray-400'">-->
<!--                                <component :is="sub.icon" class="w-6 h-6"/>-->
<!--                            </div>-->

<!--                            <span class="text-sm font-medium">{{ sub.label }}</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </transition>-->
<!--        </div>-->

<!--        &lt;!&ndash; MAIN CONTENT &ndash;&gt;-->
<!--        <div class="flex-1 justify-between bg-gray-100 relative">-->

<!--            <div class="max-w-screen-2xl mx-auto">-->
<!--                &lt;!&ndash; Header &ndash;&gt;-->
<!--                <app-header></app-header>-->

<!--                &lt;!&ndash; Main content &ndash;&gt;-->
<!--                <main class="flex-1">-->
<!--                    &lt;!&ndash; page title &ndash;&gt;-->
<!--                    <router-view></router-view>-->
<!--                </main>-->

<!--            </div>-->

<!--            &lt;!&ndash; Footer &ndash;&gt;-->
<!--&lt;!&ndash;            <footer class="relative bg-white text-primary p-4 py-6 text-center bottom-0">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="flex justify-end gap-x-2 mr-10">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <router-link class="font-medium" to="/contact-us">CONTACT US</router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <router-link class="font-medium" to="#">FAQS</router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </footer>&ndash;&gt;-->
<!--        </div>-->

<!--    </div>-->
<!--</template>-->

<!--<script setup>-->
<!--import {ref} from 'vue'-->
<!--import {-->
<!--    ArrowRightLeft,-->
<!--    BadgeDollarSign,-->
<!--    CreditCard,-->
<!--    Home,-->
<!--    ReceiptText,-->
<!--    RefreshCw,-->
<!--    Settings,-->
<!--    SquareChartGantt,-->
<!--    Landmark,-->
<!--    ClipboardClock,-->
<!--    PiggyBank,-->
<!--    Lock,-->
<!--    History,-->
<!--    SquarePen,-->
<!--    Star,-->
<!--} from 'lucide-vue-next'-->
<!--import {useRouter} from 'vue-router'-->
<!--import AppHeader from "@/components/AppHeader";-->

<!--const router = useRouter();-->
<!--const isOpen = ref(false)-->
<!--const activeSubmenu = ref(null)-->
<!--const activeParent = ref(null);-->
<!--const activeSubmenuItem = ref(null);-->

<!--function openMainMenu() {-->
<!--    isOpen.value = true;-->
<!--}-->

<!--function closeMainMenu() {-->
<!--    isOpen.value = false;-->
<!--}-->

<!--function openSubmenu(index) {-->
<!--    activeSubmenu.value = index-->
<!--    // isOpen.value = true-->
<!--}-->

<!--function closeSubmenu() {-->
<!--    activeSubmenu.value = null-->
<!--}-->

<!--function goToPage(route, si) {-->
<!--    if (!route) return;-->
<!--    activeParent.value = activeSubmenu.value; // parent index-->
<!--    activeSubmenuItem.value = si;            // sub index-->
<!--    router.push(route);-->
<!--}-->

<!--const handleLogout = async () => {-->
<!--  console.log('User logged out successfully')-->
<!--  localStorage.removeItem('token') // حذف توکن-->
<!--  closeMainMenu()                   // بستن منو-->
<!--  closeSubmenu()                    // بستن زیرمنو-->
<!--  router.push('/login')             // هدایت به صفحه لاگین-->
<!--}-->


<!--const menuItems = [-->
<!--    {label: 'Bison Mobile®', icon: Home, route: '/'},-->
<!--    {label: 'Money Transfer', icon: ArrowRightLeft, route: '/transfer'},-->
<!--    {-->
<!--        label: 'Pay',-->
<!--        icon: CreditCard,-->
<!--        route: '/pay',-->
<!--        submenu: [-->
<!--            {label: 'Services', route: '/pay/services', icon: ReceiptText},-->
<!--            {label: 'State', route: '/pay/state', icon: Landmark},-->
<!--        ]-->
<!--    },-->
<!--    {label: 'Currency Exchange', icon: RefreshCw, route: '/currency'},-->
<!--    {-->
<!--        label: 'For You',-->
<!--        icon: BadgeDollarSign,-->
<!--        route: '/operations',-->
<!--        submenu: [-->
<!--            {label: 'Pending Operations', route: '/operations', icon: ClipboardClock},-->
<!--        ]-->
<!--    },-->
<!--    {-->
<!--        label: 'View',-->
<!--        icon: SquareChartGantt,-->
<!--        route: '/view',-->
<!--        submenu: [-->
<!--            {label: 'Balance', route: '/view/balance', icon: PiggyBank},-->
<!--        ]-->
<!--    },-->

<!--    {-->
<!--        label: 'Personal Setup',-->
<!--        icon: Settings,-->
<!--        route: '/setting',-->
<!--        submenu: [-->
<!--            {label: 'Change Password', route: '/setting/change-password', icon: Lock},-->
<!--            {label: 'Activity Log', route: '/setting/activity-log', icon: History},-->
<!--            {label: 'Custom Account', route: '/setting/custom-account', icon: SquarePen},-->
<!--            {label: 'Frequent Beneficiaries', route: '/setting/beneficiaries', icon: Star},-->
<!--        ]-->
<!--    },-->
<!--    // {label: 'Logout', icon: LogOut, route: '/Login'},-->

<!--    // ... بقیه آیتم‌ها-->
<!--]-->
<!--</script>-->

<!--<style scoped>-->
<!--/* transition */-->
<!--.submenu-fade-enter-active,-->
<!--.submenu-fade-leave-active {-->
<!--    transition: all 0.16s ease;-->
<!--}-->

<!--.submenu-fade-enter-from,-->
<!--.submenu-fade-leave-to {-->
<!--    opacity: 0;-->
<!--    transform: translateX(-6px);-->
<!--}-->

<!--</style>-->



<template>
  <div class="flex">
    <!-- SIDEBAR -->
    <div
        :class="isOpen ? 'w-56' : 'w-16'"
        class="relative min-h-screen bg-primary text-white flex flex-col pt-40 pb-4 transition-all duration-300 rounded-r-xl"
        @mouseenter="openMainMenu"
        @mouseleave="closeMainMenu(); closeSubmenu()"
    >
      <div class="flex flex-col gap-2 mt-6 px-2">
        <template v-for="(item, index) in menuItems" :key="index">
          <!-- اگر آیتم زیرمنو دارد -->
          <div v-if="item.submenu" @mouseenter="openSubmenu(index)">
            <div
                :class="[
                activeParent === index ? 'bg-white text-primary' : '',
                'hover:bg-white hover:text-primary'
              ]"
                class="flex items-center gap-3 cursor-pointer px-3 py-2 rounded-md transition"
            >
              <component :is="item.icon" class="w-5 h-5"/>
              <span v-if="isOpen" class="whitespace-nowrap">{{ item.label }}</span>
            </div>
          </div>

          <!-- اگر آیتم Logout است -->
          <div
              v-else-if="item.action === 'logout'"
              @click="handleLogout"
              class="flex items-center gap-3 px-3 py-2 rounded-md transition hover:bg-white hover:text-primary cursor-pointer"
          >
            <component :is="item.icon" class="w-5 h-5"/>
            <span v-if="isOpen" class="whitespace-nowrap">{{ item.label }}</span>
          </div>

          <!-- بقیه آیتم‌ها -->
          <router-link
              v-else
              :to="item.route"
              active-class="bg-white text-primary"
              class="flex items-center gap-3 px-3 py-2 rounded-md transition hover:bg-white hover:text-primary"
              exact-active-class="bg-white text-primary"
          >
            <component :is="item.icon" class="w-5 h-5"/>
            <span v-if="isOpen" class="whitespace-nowrap">{{ item.label }}</span>
          </router-link>
        </template>
      </div>

      <!-- SUBMENU -->
      <transition name="submenu-fade">
        <div
            v-if="activeSubmenu !== null && menuItems[activeSubmenu].submenu"
            class="absolute left-full top-0 h-full w-72 bg-white text-gray-800 rounded-lg shadow-lg p-4 z-50 overflow-auto"
        >
          <div class="text-lg text-center font-semibold text-gray-500 mt-20 mb-4 uppercase">
            {{ menuItems[activeSubmenu].label }}
          </div>

          <div class="flex flex-col gap-2">
            <div
                v-for="(sub, si) in menuItems[activeSubmenu].submenu"
                :key="si"
                :class="activeSubmenuItem === si && activeParent === activeSubmenu ? 'bg-white text-primary' : 'hover:bg-orange-50 hover:text-orange-600'"
                class="flex items-center gap-3 rounded-md cursor-pointer transition"
                @click="goToPage(sub.route, si)"
            >
              <div class="w-12 h-12 flex justify-center items-center rounded-md border"
                   :class="activeSubmenuItem === si && activeParent === activeSubmenu ? 'border-primary' : 'border-gray-400'">
                <component :is="sub.icon" class="w-6 h-6"/>
              </div>
              <span class="text-sm font-medium">{{ sub.label }}</span>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- MAIN CONTENT -->
    <div class="flex-1 justify-between bg-gray-100 relative">
      <div class="max-w-screen-2xl mx-auto">
        <app-header></app-header>
        <main class="flex-1">
          <router-view></router-view>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import AppHeader from "@/components/AppHeader";
import {
  ArrowRightLeft,
  BadgeDollarSign,
  CreditCard,
  Home,
  LogOut,
  ReceiptText,
  RefreshCw,
  Settings,
  SquareChartGantt,
  Landmark,
  ClipboardClock,
  PiggyBank,
  Lock,
  History,
  SquarePen,
  Star,
} from 'lucide-vue-next'

const router = useRouter()
const isOpen = ref(false)
const activeSubmenu = ref(null)
const activeParent = ref(null)
const activeSubmenuItem = ref(null)

function openMainMenu() { isOpen.value = true }
function closeMainMenu() { isOpen.value = false }
function openSubmenu(index) { activeSubmenu.value = index }
function closeSubmenu() { activeSubmenu.value = null }
function goToPage(route, si) {
  if (!route) return
  activeParent.value = activeSubmenu.value
  activeSubmenuItem.value = si
  router.push(route)
}

const handleLogout = () => {
  console.log('User logged out successfully')
  localStorage.removeItem('token')
  closeMainMenu()
  closeSubmenu()
  router.push('/login')
}

const menuItems = [
  { label: 'Bison Mobile®', icon: Home, route: '/' },
  { label: 'Money Transfer', icon: ArrowRightLeft, route: '/transfer' },
  {
    label: 'Pay', icon: CreditCard, route: '/pay', submenu: [
      { label: 'Services', route: '/pay/services', icon: ReceiptText },
      { label: 'State', route: '/pay/state', icon: Landmark },
    ]
  },
  { label: 'Currency Exchange', icon: RefreshCw, route: '/currency' },
  {
    label: 'For You', icon: BadgeDollarSign, route: '/operations', submenu: [
      { label: 'Pending Operations', route: '/operations', icon: ClipboardClock },
    ]
  },
  {
    label: 'View', icon: SquareChartGantt, route: '/view', submenu: [
      { label: 'Balance', route: '/view/balance', icon: PiggyBank },
    ]
  },
  {
    label: 'Personal Setup', icon: Settings, route: '/setting', submenu: [
      { label: 'Change Password', route: '/setting/change-password', icon: Lock },
      { label: 'Activity Log', route: '/setting/activity-log', icon: History },
      { label: 'Custom Account', route: '/setting/custom-account', icon: SquarePen },
      { label: 'Frequent Beneficiaries', route: '/setting/beneficiaries', icon: Star },
    ]
  },
  // Logout عملیاتی
  { label: 'Logout', icon: LogOut, action: 'logout' },
]
</script>

<style scoped>
.submenu-fade-enter-active,
.submenu-fade-leave-active { transition: all 0.16s ease; }
.submenu-fade-enter-from,
.submenu-fade-leave-to { opacity: 0; transform: translateX(-6px); }
</style>
